var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.5V15.5C22 20.5 20 22.5 15 22.5H9C4 22.5 2 20.5 2 15.5V9.5C2 4.5 4 2.5 9 2.5H14",
    fill: "#134A70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.5H18C15 10.5 14 9.5 14 6.5V2.5L22 10.5Z",
    fill: "#3E7AA3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60428 13.572C9.60428 13.784 9.55428 13.984 9.45428 14.172C9.35428 14.36 9.19428 14.514 8.97428 14.634C8.75428 14.75 8.47228 14.808 8.12828 14.808H7.37228V16.5H6.68828V12.33H8.12828C8.44828 12.33 8.71828 12.386 8.93828 12.498C9.16228 12.606 9.32828 12.754 9.43628 12.942C9.54828 13.13 9.60428 13.34 9.60428 13.572ZM8.12828 14.25C8.38828 14.25 8.58228 14.192 8.71028 14.076C8.83828 13.956 8.90228 13.788 8.90228 13.572C8.90228 13.116 8.64428 12.888 8.12828 12.888H7.37228V14.25H8.12828ZM13.1726 13.572C13.1726 13.784 13.1226 13.984 13.0226 14.172C12.9226 14.36 12.7626 14.514 12.5426 14.634C12.3226 14.75 12.0406 14.808 11.6966 14.808H10.9406V16.5H10.2566V12.33H11.6966C12.0166 12.33 12.2866 12.386 12.5066 12.498C12.7306 12.606 12.8966 12.754 13.0046 12.942C13.1166 13.13 13.1726 13.34 13.1726 13.572ZM11.6966 14.25C11.9566 14.25 12.1506 14.192 12.2786 14.076C12.4066 13.956 12.4706 13.788 12.4706 13.572C12.4706 13.116 12.2126 12.888 11.6966 12.888H10.9406V14.25H11.6966ZM16.519 12.33V12.888H15.409V16.5H14.725V12.888H13.609V12.33H16.519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.4c79854ff3e05387618b7edc0e607b5d.svg";
export { ForwardRef as ReactComponent };